import { AbstractControl, FormGroup } from '@angular/forms';

const findFirstFormGroup = (control: AbstractControl): FormGroup | null => {
  let parent = control.parent;

  // Traverse up the hierarchy until we find a FormGroup or reach the root
  while (parent && !(parent instanceof FormGroup)) {
    parent = parent.parent;
  }

  return parent instanceof FormGroup ? parent : null;
};

export default findFirstFormGroup;
